import { Observable } from 'rxjs';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActionAsideMenuOpenClose } from '@global-actions/action-aside-menu/action-aside-menu';
import { Select } from '@ngxs/store';

@Component({
  selector: 'app-app-router',
  templateUrl: './app-router.component.html',
  styleUrls: ['./app-router.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AppRouterComponent {
  @Select('stateAsideMenu') menuState!: Observable<ActionAsideMenuOpenClose>;

  constructor() {}
}
